import { computed, type Ref } from 'vue';

/**
 * Creates a computed string proxy for a boolean ref.
 *
 * Use this hook when business logic stores a boolean, but a form control
 * (for example, `EliRadioGroup`) requires string values.
 *
 * @param realValue - Ref that stores the boolean value in business logic.
 * @param trueValue - String representation of `true` in the form control.
 * @param falseValue - String representation of `false` in the form control.
 */
const useProxyBooleanToString = (
    realValue: Ref<boolean>,
    trueValue: string = 'true',
    falseValue: string = 'false',
) => {
    return computed<string>({
        get: () => realValue.value ? trueValue : falseValue,
        set: (newStringValue: string) => {
            realValue.value = newStringValue === trueValue;
        },
    });
};

export {
    useProxyBooleanToString,
};
